
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.5 14.513V4.25a.25.25 0 0 0-.25-.25h-1a.25.25 0 0 0-.25.25V9h-2V4.25a.25.25 0 0 0-.25-.25h-1a.25.25 0 0 0-.25.25V9h-2V4.25a.25.25 0 0 0-.25-.25h-1a.25.25 0 0 0-.25.25V9h-2V5.625A1.627 1.627 0 0 0 14.375 4h-8.75A1.627 1.627 0 0 0 4 5.625v20.75A1.627 1.627 0 0 0 5.625 28h20.75A1.627 1.627 0 0 0 28 26.375v-10.25a1.622 1.622 0 0 0-1.5-1.612ZM25 10.5v4h-2v-4h2Zm-3.5 0v4h-2v-4h2Zm-5.5 0h2v4h-2v-4Zm10.5 15.875a.125.125 0 0 1-.125.125H5.625a.125.125 0 0 1-.125-.125V24.5h21v1.875Zm0-3.375h-21V5.625a.125.125 0 0 1 .125-.125h8.75a.125.125 0 0 1 .125.125v10.25a.125.125 0 0 0 .125.125h11.75a.125.125 0 0 1 .125.125V23Z"}})])
          )
        }
      }
    